// extracted by mini-css-extract-plugin
export default {"container":"film-modal_container__3CDdb","visible":"film-modal_visible__q1c9i","inner":"film-modal_inner__35L3k"};